<template>
  <div class="tip-audio">
    <div class="controls">
      <textbook-category-select @change="selectLevels" />
    </div>

    <el-table
      v-if="levels && levels.length > 0"
      :data="levels"
      style="width: 100%;border-top: 1px solid #ebeef5;border-right: 1px solid #ebeef5; "
      :show-header="false"
    >
      <el-table-column
        type="expand"
        label="Level"
        width="80"
      >
        <template slot-scope="scope">
          <table class="audios">
            <tr
              v-for="(name, type) of questionTypes"
              :key="type"
              class="audio-item"
            >
              <td class="audio-name">
                {{ name }}
              </td>
              <td class="audio-player">
                <div style="width: 30px; display: inline-block;">
                  <audio-player
                    v-if="scope.row.audios[type]"
                    :url="scope.row.audios[type]"
                  />
                </div>

                <div style="display: inline-block; margin-left: 10px;">
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    with-credentials
                    :data="{ meta: JSON.stringify({ type: type, levelId: scope.row.id }) }"
                    :show-file-list="false"
                    :on-error="uploadFailHandler"
                    :on-success="uploadSuccessHandler"
                  >
                    <el-button
                      size="small"
                      type="text"
                    >
                      上传
                    </el-button>
                  </el-upload>
                </div>
              </td>
            </tr>
          </table>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <span style="float: left">{{ scope.row.name }}</span>
          <span
            v-if="scope.row.isUsed === 0"
            style="float: right; color: #8492a6; font-size: 13p"
          >{{ $t('禁用') }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style lang="less" scoped>
.controls {
  position: relative;
  .add {
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}

.audios {
  width: 100%;
  margin-top: -20px;
  margin-bottom: -20px;
  margin-left: 40px;
  line-height: 30px;
  border-collapse: collapse;
  .audio-item {
    .audio-name {
      padding-left: 10px;
      padding-right: 10px;
      width: 200px;
    }
  }
  .question-type-name {
    display: inline-block;
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:unit-test');
import { find } from 'lodash';
import audioPlayer from '../components/audio_player';
import textbookCategorySelect from '../components/textbook_category_select';
import { QUESTION_TYPES, TEXTBOOK_VERSIONS } from '../constants';
import axios from 'axios';

export default {
	components: {
		audioPlayer,
		textbookCategorySelect
	},
	data() {
		return {
			uploadUrl: `${API_BASE_URL}/api/files`, /* eslint no-undef:0 */
			// 级联配置
			seriesSelectionProps: {
				lazy: true,
				value: 'code',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					if (node.value) {
						const courseType = node.value;
						axios
							.get('/api/textbooks/category', {
								params: {
									courseType
								}
							})
							.then(categories => {
								categories.forEach(category => {
									// 没有子节点
									category.leaf = true;
									category.code = category.categoryCode;
									category.name = category.categoryName;
								});
								resolve(categories);
							});
					} else {
						resolve();
					}
				}
			},
			textbookVersions: TEXTBOOK_VERSIONS,
			questionTypes: QUESTION_TYPES,
			series: [],
			levels: []
		};
	},
	methods: {
		async selectLevels(levels) {
			debug('[selectLevels] levels: %o', levels);
			const tipAudios = await Promise.all(
				levels.map(({ id }) =>
					axios.get('/api/tipsAudio', { params: { levelId: id } })
				)
			);
			for (let i = 0; i < levels.length; i++) {
				levels[i].audios = tipAudios[i].reduce((audios, audio) => {
					audios[audio.questionType] = audio.audio;
					return audios;
				}, {});
			}
			this.levels = levels;
		},

		uploadFailHandler() {
			this.$message.error('文件上传失败');
		},

		async uploadSuccessHandler(res) {
			let { url, meta } = res;
			try {
				meta = JSON.parse(meta);
			} catch (ignord) {}

			await axios.post('/api/tipsAudio', {
				levelId: meta.levelId,
				questionType: meta.type,
				audio: res.url
			});

			const level = find(this.levels, { id: meta.levelId });
			this.$set(level.audios, meta.type, res.url);
		}
	}
};
</script>